export default __webpack_public_path__ + "static/media/sumit-nss-1.3aa01740.jpeg";